import { useEffect } from "react";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Lightweight SEO/GEO head manager: meta tags, Open Graph, Twitter cards + JSON-LD.
export default function Seo({ title, description, image, type = "website", jsonLd }) {
  useEffect(() => {
    const canonical = typeof window !== "undefined" ? window.location.href : "";
    const shareImage = image || (typeof window !== "undefined" ? `${window.location.origin}/sme-share.jpg` : "");
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", shareImage);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:site_name", "S/ME");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", shareImage);
    setLink("canonical", canonical);

    const ID = "seo-jsonld";
    let script = document.getElementById(ID);
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = ID;
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, image, type, jsonLd]);

  return null;
}
